import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IArquivoDTO, IDenunciaDTO } from "../../../types/denuncia";
import { Denuncia } from "../../../services/Denuncia";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";

export const useReport = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [denuncia, setDenuncia] = useState<IDenunciaDTO>({} as IDenunciaDTO);
  const { setIsLoad } = useContextSite();

  const getDenuncia = useCallback(() => {
    if (!id) return;

    setIsLoad(true);
    Denuncia.getById({ uuidDenuncia: id })
      .then(({ data }) => {
        setDenuncia(data);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }, [id]);

  useEffect(() => {
    getDenuncia();
  }, [id]);

  const downloadArquivo = (arquivo: IArquivoDTO) => {
    const baseUrl = process.env.REACT_APP_PESQUISA_API_URL || "";
    if (!baseUrl) {
      console.error("A variável de ambiente da API não está configurada.");
      return;
    }

    const downloadUrl = `${baseUrl}/denuncia/${id}/download-arquivo/${arquivo.uuid}`;

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = arquivo.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return { navigate, denuncia, downloadArquivo };
};
